export class SecurityResourceNotificationArguments {
    'providerResourceId';
    'resourceName';
    'securityScan';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityScan",
            "baseName": "securityScan",
            "type": "SecurityScanNotificationData",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecurityResourceNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
